module.exports = __webpack_public_path__ + "img/beneficii@2x.b947ecc2.png";